import React, { useContext } from 'react';

import { ItemsList } from '@/components/shared/ItemsList';

import { CopilotContext } from '../CopilotPage';

const CopilotPrepareSongs: React.FC = () => {
	const { pcoSongs } = useContext(CopilotContext);

	return (
		<>
			<h2>Progress</h2>
			<ItemsList
				items={[
					{
						label: 'Account verified',
						checked: true,
					},
					{
						label: `Preparing songs (found ${pcoSongs.length} songs)...`,
						checked: false,
					},
				]}
			/>
		</>
	);
};

export default CopilotPrepareSongs;
